// Check if process is available (for browser environment)
const getEnvVar = (key, defaultValue) => {
  return defaultValue;
};

export const AGORA_CHAT_APP_KEY = getEnvVar('REACT_APP_AGORA_CHAT_APP_KEY', "411375860#1581825");
export const AGORA_CHAT_ORG_NAME = getEnvVar('REACT_APP_AGORA_CHAT_ORG_NAME', "411375860");
export const AGORA_CHAT_APP_NAME = getEnvVar('REACT_APP_AGORA_CHAT_APP_NAME', "1581825");
export const AGORA_CHAT_APP_ID = getEnvVar('REACT_APP_AGORA_CHAT_APP_ID', "ca08af6f975e4f0a9baac3c6f975d79c");

export const BACKEND_URL = getEnvVar('REACT_APP_BACKEND_URL', "https://backend-dev.gtcarlife.com/api/");